import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  GET,
  Params,
} from '@app/core/api';

import { City } from '@app/core/types/city.interface';
import { Province } from '@app/core/types/province.interface';


@ApiController('api/app/setting')
@Injectable({
  providedIn: 'root',
})
export class AppSettingApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/province')
  getProvinces(): Observable<ApiResponse<Province[]>> {
    return {} as Observable<ApiResponse<Province[]>>;
  }

  @GET('/province/:provinceId/city')
  getCities(@Params('provinceId') provinceId: number): Observable<ApiResponse<City[]>> {
    return {} as Observable<ApiResponse<City[]>>;
  }
}
